import { runtimeConfig } from '@/config/runtime-config'
import { createApiClient } from '@/lib/api/http-client'
import { getStoredToken } from '@/lib/auth/token-storage'

export type WecomBindingStatus =
  | 'completed'
  | 'confirmed'
  | 'conflict'
  | 'created'
  | 'expired'
  | 'portal_authenticated'
  | 'wecom_verified'

export interface WecomBindingSession {
  app_display_name: string
  authorize_url: string | null
  error_code?: string | null
  expires_at: string
  status: WecomBindingStatus
}

interface SuccessEnvelope<T> {
  code: 'success'
  data: T
}

const publicApiClient = createApiClient({
  baseUrl: runtimeConfig.apiBaseUrl,
})

const authenticatedApiClient = createApiClient({
  baseUrl: runtimeConfig.apiBaseUrl,
  getToken: () => getStoredToken('user'),
  portal: 'user',
})

function bindingPath(bindingToken: string, suffix = '') {
  return `/im/wecom/bind/${encodeURIComponent(bindingToken)}${suffix}`
}

export async function getWecomBindingSession(bindingToken: string) {
  const response = await publicApiClient.request<SuccessEnvelope<WecomBindingSession>>(
    bindingPath(bindingToken, '/session'),
  )
  return response.data
}

/** 免密登录返回后，服务端核对发送者现有绑定并收口 bot 提示。 */
export async function resumeWecomBinding(bindingToken: string) {
  const response = await authenticatedApiClient.request<SuccessEnvelope<WecomBindingSession>>(
    bindingPath(bindingToken, '/resume'),
    { method: 'POST' },
  )
  return response.data
}
